import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, fmt } from "@/api";
import { useApp } from "@/context/AppContext";
import { Plus, Minus, X, Users, Package, Check } from "lucide-react";

export default function KitDetail() {
  const { slug } = useParams();
  const [k, setK] = useState(null);
  const { addToCart } = useApp();
  const nav = useNavigate();

  useEffect(()=>{ api.get(`/kits/${slug}`).then(({data})=>setK(data)); }, [slug]);
  if (!k) return <div className="p-20 text-center">Loading...</div>;

  const update = (idx, delta) => setK(x=>{const items=[...x.items]; items[idx]={...items[idx], qty:Math.max(1, items[idx].qty+delta)}; return {...x, items};});
  const remove = (idx) => setK(x=>({...x, items:x.items.filter((_,i)=>i!==idx)}));
  const itemsTotal = k.items.reduce((s,i)=>s+i.price*i.qty, 0);

  const addAll = () => { k.items.forEach(i => addToCart({product_id:`kit-${k.id}-${i.name}`, name:i.name, price:i.price, image:i.image, kit:true}, i.qty)); nav("/cart"); };

  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      <div className="grid md:grid-cols-[1.1fr_1fr] gap-10 items-start">
        <div className="rounded-3xl overflow-hidden aspect-[4/3] border border-border">
          <img src={k.image} className="w-full h-full object-cover" alt=""/>
        </div>
        <div>
          <div className="section-label">{k.puja} · {k.kit_type} Kit</div>
          <h1 className="font-serif text-4xl mt-2">{k.name}</h1>
          <div className="mt-3 flex flex-wrap gap-4 text-sm text-muted-foreground">
            <span className="flex items-center gap-2"><Users className="w-4 h-4"/>Serves {k.serves || k.family_size}</span>
            <span className="flex items-center gap-2"><Package className="w-4 h-4"/>{k.items.length} items</span>
          </div>
          <p className="mt-4 text-foreground/80">{k.description}</p>
          <div className="mt-5 flex items-baseline gap-3">
            <span className="text-3xl font-semibold text-primary">{fmt(k.price)}</span>
            {k.mrp > k.price && <span className="line-through text-muted-foreground">{fmt(k.mrp)}</span>}
            {k.mrp > k.price && <span className="bg-accent text-white text-xs px-2 py-1 rounded-full">Save {fmt(k.mrp-k.price)}</span>}
          </div>
          <button onClick={addAll} data-testid="add-full-kit-btn" className="mt-6 pk-btn-primary w-full sm:w-auto"><Check className="w-4 h-4"/>Add Complete Kit to Cart</button>
        </div>
      </div>

      <div className="mt-14">
        <h2 className="font-serif text-2xl mb-2">What's included</h2>
        <p className="text-sm text-muted-foreground mb-6">Customize quantities or remove items you don't need. Individual total: <b className="text-primary">{fmt(itemsTotal)}</b></p>
        <div className="grid md:grid-cols-2 gap-3">
          {k.items.map((it,idx)=>(
            <div key={idx} className="flex items-center gap-4 p-4 rounded-xl border border-border bg-white">
              <img src={it.image} alt="" className="w-16 h-16 rounded-lg object-cover"/>
              <div className="flex-1">
                <div className="font-medium">{it.name}</div>
                <div className="text-sm text-muted-foreground">{fmt(it.price)} · {fmt(it.price*it.qty)} total</div>
              </div>
              <div className="flex items-center gap-2">
                <button onClick={()=>update(idx,-1)} className="w-8 h-8 rounded-full border border-border grid place-items-center"><Minus className="w-3 h-3"/></button>
                <span className="w-6 text-center">{it.qty}</span>
                <button onClick={()=>update(idx,1)} className="w-8 h-8 rounded-full border border-border grid place-items-center"><Plus className="w-3 h-3"/></button>
              </div>
              <button onClick={()=>remove(idx)} className="p-2 text-muted-foreground hover:text-primary"><X className="w-4 h-4"/></button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
